/*
 * @Author: your name
 * @Date: 2020-12-16 19:22:59
 * @LastEditTime: 2021-01-05 14:17:40
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\modeldemo\Scene.js
 */
/**
 * @Description 场景类
 * @Author iCEA
 * @Date 2020-10-29
 * @Version 1.0
 */

import * as THREE from 'three'

class Scene {
  /**
   * 场景对象构造函数
   */
  constructor () {
    /**
     * @type {THREE.Scene} Threejs的场景对象
     */
    this.scene = null
    /**
     * @type {THREE.Light} Threejs的灯光对象
     */
    this.light = null

    this.initScene()
  }

  /**
   * 场景初始化
   */
  initScene () {
    this.scene = new THREE.Scene()
    this.scene.background = new THREE.Color(0x222222)
    this.initLight()
    this.initContent()
  }

  /**
   * 灯光初始化，目前仅有环境光白光
   */
  initLight () {
    // this.scene.add(new THREE.AmbientLight(0xffffff))
    /*
    this.scene.add(new THREE.AmbientLight(0x444444))
    this.light = new THREE.PointLight(0xffffff)
    this.light.position.set(0, 100000, 180000)
    //告诉平行光需要开启阴影投射
    this.light.castShadow = true
    this.scene.add(this.light)

    this.light = new THREE.PointLight(0xdddddd)
    this.light.position.set(0, -150000, -180000)
    //告诉平行光需要开启阴影投射
    this.light.castShadow = true
    this.scene.add(this.light)
     */
  }

  /**
   * 场景其他内容初始化，辅助坐标系等
   */
  initContent () {
    // const axisHelper = new THREE.AxesHelper(5000) //size
    // this.scene.add(axisHelper)
  }
}

export {
  Scene
}
